export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  border: true,
  index: false,
  viewBtn: false,
  editBtn:false,
  delBtn:false,
  labelWidth: 120,
  selection: true,
  dialogClickModal: false,
  column: [
    {
      label: "",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },{
      label: "应用名称",
      prop: "product",
      type: "select",
      span: 12,
      dicUrl: "/api/blade-system/dict/dictionary?code=app_product",
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      cascader: ["minVersion"],
      search: true,
      rules: [
        {
          required: true,
          message: "请选择应用名称",
          trigger: "blur",
        },
      ],
    },
    {
      label: "平台",
      prop: "platform",
      type: "select",
      span: 12,
      dicUrl: "/api/blade-system/dict/dictionary?code=app_platform",
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      cascader: ["minVersion"],
      search: true,
      rules: [
        {
          required: true,
          message: "请选择平台",
          trigger: "blur",
        },
      ],
    },
    {
      label: "版本号",
      prop: "newVersion",
      type: "input",
      search: true,
      rules: [
        {
          required: true,
          pattern: /^(\d+(\.\d+){2,3})$/,
          // pattern: /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/,
          message: "请正确版本号, 格式如下: 主版本.次版本.修订版本",
          trigger: "blur",
        },
      ],
      placeholder: "请输入版本号, 格式如下: 1.1.1",
    },
    {
      label: "低版本强制更新",
      prop: "minVersion",
      type: "select",
      props: {
        label: "newVersion",
        value: "newVersion",
      },
      dicUrl: `/api/blade-appVersion/appVersion/select?platform={{platform}}&product={{product}}`,
      placeholder: "请选择最小支持版本号, 不填则强制更新",
    },
    {
      label: "文件地址",
      prop: "apkUrl",
      type: "upload",
      propsHttp: {
        res: "data",
        url: "link",
        name: "originName",
      },
      dataType: "string",
      limit: 1,
      action: "/api/blade-resource/oss/endpoint/put-file",
      rules: [
        {
          required: true,
          message: "请上传文件",
          trigger: "blur",
        },
      ],
    },
    {
      label: "文件大小(KB)",
      prop: "apkSize",
      type: "input",
      append: "KB",
    },
    {
      label: "md5值",
      prop: "md5",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "更新标题",
      prop: "title",
      type: "textarea",
      span: 24,
      minRows: 4,
      rules: [
        {
          required: true,
          message: "请输入更新标题",
          trigger: "blur",
        },
      ]
    },
    {
      label: "更新内容",
      prop: "content",
      type: "textarea",
      span: 24,
      minRows: 4,
      hide: true,

    },
    {
      label: "租户ID",
      prop: "tenantId",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建人",
      prop: "createUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建部门",
      prop: "createDept",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改人",
      prop: "updateUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改时间",
      prop: "updateTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "状态",
      prop: "status",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "是否已删除",
      prop: "isDeleted",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
  ],
};
